import FeaturedProds from './FeaturedProds';
import FooterAts from './FooterAts';
import HeaderATS from './HeaderAts';
import HeroIntro from './HeroIntro';

function HomePage() {
  return (
    <div className="page">
      <HeaderATS />
      <HeroIntro />
      <FeaturedProds />
      <FooterAts />
    </div>
  );
}

export default HomePage;